"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _underscore = require("underscore");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _CurrentOwnerContainer = _interopRequireDefault(require("crm_internal/containers/CurrentOwnerContainer"));

var _UserStore = _interopRequireDefault(require("crm_data/user/UserStore"));

var REQUIRED_DATA_TYPE_MAP = {
  eventType: 'string',
  itemType: 'string',
  created: 'number'
};

var _requiredDataInvariantCheck = function _requiredDataInvariantCheck(requiredData) {
  return Object.keys(REQUIRED_DATA_TYPE_MAP).forEach(function (key) {
    var property = requiredData[key];
    var expectedType = REQUIRED_DATA_TYPE_MAP[key];
    var actualType = (0, _typeof2.default)(property);
    return (0, _invariant.default)(actualType === expectedType, 'Sample event error: required property "%s" expected type "%s". Received: "%s"', key, expectedType, actualType);
  });
};

var makeBaseSampleTimelineEvent = function makeBaseSampleTimelineEvent(requiredData) {
  requiredData = requiredData || {};

  var USER_ID = _UserStore.default.get('user_id');

  var PORTAL_ID = _hubspot.default.get();

  var OWNER_ID = _CurrentOwnerContainer.default.get();

  _requiredDataInvariantCheck(requiredData);

  var _requiredData = requiredData,
      eventType = _requiredData.eventType,
      itemType = _requiredData.itemType,
      created = _requiredData.created,
      timestamp = _requiredData.timestamp;
  var SampleEvent = {
    etype: eventType,
    id: eventType + "-" + created + "-" + (0, _underscore.uniqueId)(),
    timestamp: timestamp,
    eventData: {
      associations: {
        companyIds: [],
        contactIds: [],
        dealIds: [],
        ownerIds: [],
        workflowIds: []
      },
      attachments: [],
      engagement: {
        isSample: true,
        active: true,
        createdAt: created,
        createdBy: USER_ID,
        id: "sample-" + itemType + "-" + (0, _underscore.uniqueId)(),
        lastUpdated: created,
        modifiedBy: USER_ID,
        ownerId: OWNER_ID,
        portalId: PORTAL_ID,
        timestamp: timestamp,
        type: itemType
      },
      metadata: {}
    }
  };
  return SampleEvent;
};

var _default = makeBaseSampleTimelineEvent;
exports.default = _default;
module.exports = exports.default;